<mat-toolbar>
  @if (inProgress) {
    <spinner [spinnerSize]="buttonSize === ButtonSize.MEDIUM ? 32 : 42"></spinner>
  } @else {
    @if (noDefault) {
      <button
        eopButton
        [size]="buttonSize"
        [disabled]="disabled"
        [matMenuTriggerFor]="menu"
        [leftIcon]="defaultIcon"
        [rightIcon]="dropdownIsOpen ? 'small-chevron-up-filled' : 'small-chevron-down-filled'"
        [attr.data-test]="dataTestId"
        (click)="openDropdown()">
        {{ defaultLabel }}
      </button>
    } @else {
      <button
        eopButton
        [size]="buttonSize"
        class="left-button"
        [disabled]="disabled"
        [attr.data-test]="dataTestId"
        (click)="onOptionSelect(options[0])">
        {{ options ? options[0].label : '' }}
      </button>
      <div class="divider" [ngClass]="{ disabled: disabled }"></div>
      <button
        eopButton
        [size]="buttonSize"
        class="right-button"
        [leftIcon]="dropdownIsOpen ? 'small-chevron-up-filled' : 'small-chevron-down-filled'"
        [disabled]="disabled"
        [iconButton]="true"
        [skipMinWidth]="true"
        [matMenuTriggerFor]="menu"
        [dataTestId]="'more-items'"
        (click)="openDropdown()"></button>
    }
  }
</mat-toolbar>

<mat-menu
  #menu="matMenu"
  (closed)="closeDropdown()"
  class="mat-menu-panel-buttons"
  yPosition="below">
  @for (option of options; track option.value; let i = $index) {
    <button
      class="body-l"
      mat-menu-item
      (click)="onOptionSelect(option)"
      [attr.data-test]="dataTestId + '-' + i">
      <span class="option-label">{{ option.label }}</span>
      @if (option.description) {
        <div class="option-description">{{ option.description }}</div>
      }
    </button>
  }
</mat-menu>
